import React from "react";
import _ from "lodash";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { Grid, Typography, Chip } from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import "jspdf-autotable";

import CardCommon from "../../../../components/card/CardCommon";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";
import { CustomTheme } from "../../../../types/customTheme";

export interface CustomerNodeProps {
  banner: any;
  handleEditBannerDetails: any;
  handleDeleteBannerDetails: any;
  isOwner: any;
}

const useStyles = makeStyles((theme: CustomTheme) =>
  createStyles({
    enabledBadge: {
      backgroundColor: theme.palette.custom.green.main,
      color: "#ffffff",
      fontWeight: "bold",
      fontSize: "11px",
      height: "24px",
      minWidth: "80px",
      borderRadius: "10px",
    },
    disabledBadge: {
      backgroundColor: theme.palette.custom.red.main,
      color: "#ffffff",
      fontWeight: "bold",
      fontSize: "11px",
      height: "24px",
      borderRadius: "10px",
      minWidth: "80px",
    },
    statusColumn: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    titleColumn: {
      display: "flex",
      justifyContent: "start",
      paddingLeft: "12px",
      alignItems: "center",
    },
    actionColumn: {
      display: "flex",
      justifyContent: "flex-end",
      paddingRight: "12px",
      alignItems: "center",
    },
  })
);

const BannerInfoNode: React.FunctionComponent<CustomerNodeProps> = ({
  banner,
  handleEditBannerDetails,
  handleDeleteBannerDetails,
  isOwner,
}) => {
  const classes = useStyles();

  // Determine if banner is enabled
  const isEnabled = banner?.status?.toString() === "true" || banner?.enabled === true;

  return (
    <>
      <CardCommon backgroundColor={"entity_background"}>
        <Grid container style={{ minHeight: "40px", placeItems: "center" }}>
          {/* Title Column */}
          <Grid
            item
            xs={3}
            className={classes.titleColumn}
          >
            <Typography>{banner.title}</Typography>
          </Grid>
          
          {/* SubTitle Column */}
          <Grid item xs={3}>
            <Typography align="left">{banner.subTitle}</Typography>
          </Grid>
          
          {/* Status Column */}
          <Grid item xs={2} className={classes.statusColumn}>
            <Chip
              label={isEnabled ? "ENABLED" : "DISABLED"}
              className={isEnabled ? classes.enabledBadge : classes.disabledBadge}
              size="small"
            />
          </Grid>
          
          {/* Description Column */}
          <Grid item xs={2}>
            <Typography align="left" noWrap style={{ maxWidth: "150px" }}>
              {banner.description}
            </Typography>
          </Grid>
          
          {/* Actions Column */}
          <Grid
            item
            xs={2}
            className={classes.actionColumn}
          >
            <ButtonCommon
              style={{
                fontSize: 11,
                marginRight: "12px",
                minWidth: "28px",
                height: "36px",
              }}
              disabled={!isOwner}
              variant="contained"
              color="yellow"
              onClick={() => handleEditBannerDetails(banner)}
            >
              <EditIcon />
            </ButtonCommon>
            <ButtonCommon
              style={{
                fontSize: 11,
                minWidth: "28px",
                height: "36px",
              }}
              disabled={!isOwner}
              variant="contained"
              color="red"
              onClick={() => handleDeleteBannerDetails(banner.bannerId)}
            >
              <DeleteIcon />
            </ButtonCommon>
          </Grid>
        </Grid>
      </CardCommon>
    </>
  );
};

export default BannerInfoNode;